import {
  parentalProducts,
  validateMobileNumber,
  validateMobileNumberFor20Digit,
} from "utlis/utils";
import * as Yup from "yup";

export const tpaSetupInitialValues = {
  tpa_id: "",
  cashless_contact: "",
  cashless_contact_email: "",
  cashless_contact_name: "",
  escalation_details: [{}],
};

export const productPricingValues = {
  insurer: "",
  dependent_type: "",
  are_dependents_locked: "",
  pricingFile: "",
  attribute_definition_mapping: {},
};

// export const tpaSetupScheme = Yup.object().shape({
//   tpa_id: Yup.string().required("*Required"),
//   cashless_contact: Yup.string()
//     .required("*Required"),
//   cashless_contact_email: Yup.string()
//     .email("Invalid Email ID")
//     .required("*Required"),
//   cashless_contact_name: Yup.string()
//     .required("*Required"),
//   escalation_details: Yup.array()
//     .of(
//       Yup.object().shape({
//         escalation_contact_name: Yup.string()
//           .required("*Required"),
//         escalation_contact_email: Yup.string()
//           .email("Please enter a valid email ID")
//           .required("*Required"),
//         escalation_contact: Yup.number("Please enter a valid phone no")
//           .required("*Required")
//       })
//     )
// });

export const OPTIONAL_TPA_IDS = [1, 2, 3, 5, 7, 9, 14]; // Add your comma separated TPA IDs here

export const tpaSetupScheme = Yup.object().shape({
  tpa_id: Yup.string().required("*Required"),
  tpa_userplan_unique_code: Yup.string().when("tpa_id", {
    is: (tpa_id) => tpa_id && OPTIONAL_TPA_IDS.includes(Number(tpa_id)),
    then: Yup.string().required("*Required"),
    otherwise: Yup.string(),
  }),
  escalation_details: Yup.array().of(
    Yup.array().of(
      Yup.object().shape({
        escalation_contact_name: Yup.string().required("*Required"),
        escalation_contact_email: Yup.string()
          .email("Please enter a valid email ID")
          .required("*Required"),
        escalation_contact: Yup.string()
          .matches(/^\d{10,16}$/, "Please enter a valid phone no")
          .required("*Required"),
        escalation_region: Yup.string().nullable(),
      })
    )
  ),
  cashless: Yup.array().of(
    Yup.array().of(
      Yup.object().shape({
        cashless_contact_name: Yup.string().required("*Required"),
        cashless_contact_email: Yup.string()
          .email("Please enter a valid email ID")
          .required("*Required"),
        cashless_contact: Yup.string()
          .matches(/^\d{10,16}$/, "Please enter a valid phone no")
          .required("*Required"),
        cashless_region: Yup.string().nullable(),
      })
    )
  ),
});

export const productPricingSchema = (product_name) => {
  // const nonParentalCover = !(product_name === "parental_cover"); //optional schema for nonparental
  const nonParentalCover = !(parentalProducts.includes(product_name)); //optional schema for nonparental
  const productPricingSchema = Yup.object().shape({
    insurer: Yup.string().required("*Required"),
    are_dependents_locked: Yup.string().when("dependent_type", {
      is: (value) => ["ESC", "ESCP1", "ESCP2"].includes(value),
      then: Yup.string().required("*Required"),
    }),
    // dependent_type: Yup.string().required("*Required"),
    dependent_type: Yup.string().when("insurer", {
      is: nonParentalCover,
      then: Yup.string().required("*Required"),
      otherwise: Yup.string(),
    }),
    max_children_allowed: Yup.string().when("dependent_type", {
      is: (value) => ["ESC", "ESCP1", "ESCP2"].includes(value), // condition to check
      then: Yup.string().required("*Required"),
    }),
    are_different_parent_set_allowed: Yup.string().when("dependent_type", {
      is: (value) => value === "ESCP2" || !nonParentalCover, // condition to check
      then: Yup.string().required("*Required"),
    }),
  });
  console.log(
    nonParentalCover,
    productPricingSchema,
    "here at the non paerntal"
  );
  return productPricingSchema;
};
